import React from 'react';
import { FormInstance } from 'antd/es/form';
import { get } from 'lodash';
import ProfileImageList from 'components/user/ProfileImageList';
import { moveToFirstError } from 'libs/api/errorHandle';
import { CUserType, CUserTypeColor } from 'constants/user.const';
import { EUserType } from 'enums/base.enum';
import { Button, Form, Checkbox, Typography, Input, Tag, Tooltip, List } from 'antd';
import { QuestionCircleOutlined, CheckSquareOutlined } from '@ant-design/icons';
import { SecondaryColor, FormWrapper } from 'GlobalStyles';

const { Text, Title } = Typography;
type TProfileSettingProps = {
  userType: EUserType;
  form: FormInstance;
};
const ProfileSetting = ({ userType, form }: TProfileSettingProps) => {
  const imageId = get(
    form.getFieldValue('profile_images') && form.getFieldValue('profile_images')[0],
    'response.id',
  );
  const imageUrl = get(
    form.getFieldValue('profile_images') && form.getFieldValue('profile_images')[0],
    'response.absolute_url',
  );

  return (
    <FormWrapper style={{ maxWidth: '380px', paddingTop: '0px' }}>
      <Form
        name='profile_setting'
        form={form}
        layout='vertical'
        initialValues={{ use_nickname: false }}
        className='form-inline'
      >
        <Tag color={CUserTypeColor[userType]}>{CUserType[userType]}</Tag>
        <Title level={2} style={{ marginBottom: '20px' }}>
          <span style={{ color: `${CUserTypeColor[userType]}` }}>프로필 설정</span>
          을<br />
          진행해주세요
        </Title>
        <Text strong>프로필 사진</Text>
        <Form.Item name='profile_images'>
          <ProfileImageList imageId={imageId} imageUrl={imageUrl} form={form} />
          <div
            style={{
              color: `${SecondaryColor}`,
              fontSize: '12px',
              marginBottom: '10px',
            }}
          >
            원활한 멘토링 진행을 위해, 얼굴이 잘 드러나는 사진으로 올려주세요. 얼굴 공개를 원치 않을 시 우측
            그림을 활용하셔도 됩니다.
          </div>
        </Form.Item>
        <Form.Item name={'fullname_local'} className='form-item' label='이름' rules={[{ required: true }]}>
          <Input size='large' placeholder='이름을 입력해주세요' />
        </Form.Item>
        <Form.Item name={'nickname'} className='form-item' label='닉네임' rules={[{ required: true }]}>
          <Input size='large' placeholder='닉네임을 입력해주세요' />
        </Form.Item>
        <Form.Item name={'use_nickname'} className='form-bottom' valuePropName={'checked'}>
          <Checkbox style={{ fontSize: '13px', width: '100%' }}>
            실명 대신 닉네임 사용하기.&nbsp;
            <Tooltip
              placement='top'
              color={CUserTypeColor[userType] as 'green'}
              title={
                <List split={false} style={{ width: '240px', padding: '0px 10px', color: '#fff' }}>
                  <List.Item.Meta
                    avatar={<CheckSquareOutlined />}
                    description={
                      <span style={{ color: '#fff' }}>
                        멘토링에서 닉네임을 사용할 수 있습니다. 단, 멘티의 경우, 멘토와의 원활한
                        커뮤니케이션을 위해 실명 사용을 권장합니다.
                      </span>
                    }
                  />
                </List>
              }
            >
              <QuestionCircleOutlined />
            </Tooltip>
          </Checkbox>
        </Form.Item>
        <Form.Item shouldUpdate={true} noStyle={true}>
          {() => (
            <div className='steps-action'>
              <Button
                type='primary'
                htmlType='submit'
                size='large'
                onClick={() => {
                  form.validateFields().catch((errorInfo) => {
                    moveToFirstError(form, errorInfo.errorFields);
                  });
                }}
              >
                다음
              </Button>
            </div>
          )}
        </Form.Item>
      </Form>
    </FormWrapper>
  );
};

export default ProfileSetting;
